var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _c("div", { staticClass: "page-titles border-bottom" }, [
      _c("h3", [_vm._v("Transcripts - AI Test")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-info btn-sm pull-right",
          on: {
            click: function ($event) {
              return _vm.$router.push("/account/transcripts")
            },
          },
        },
        [
          _c("i", { staticClass: "fas fa-list" }),
          _vm._v(" "),
          _c("span", { staticClass: "d-none d-sm-inline" }, [
            _vm._v(_vm._s(_vm.trans("transcript.transcript_list"))),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-0",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c("div", { staticStyle: { width: "50%", float: "left" } }, [
          _c(
            "div",
            {
              staticClass: "row",
              staticStyle: {
                background: "#fff",
                "border-radius": "20px",
                padding: "20px 20px 40px",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-12 col-sm-12",
                  staticStyle: {
                    "margin-bottom": "20px",
                    "margin-top": "20px",
                  },
                },
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.transcriptForm.text,
                        expression: "transcriptForm.text",
                      },
                    ],
                    staticClass: "form-control",
                    staticStyle: { height: "500px" },
                    attrs: { readonly: _vm.is_run },
                    domProps: { value: _vm.transcriptForm.text },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.transcriptForm,
                          "text",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-sm-12" }, [
                !_vm.is_run
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-info",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.sendText.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Start AI Test")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.is_run
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-info",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.resetText.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Reset")]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: { width: "50%", float: "left", padding: "0 0 0 40px" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#fff",
                  "border-radius": "20px",
                  padding: "40px",
                  "min-height": "638px",
                },
              },
              [
                _vm.is_run
                  ? _c(
                      "div",
                      [
                        _c("img", {
                          staticStyle: {
                            "max-width": "400px",
                            width: "80%",
                            margin: "50px auto 0",
                            opacity: "0.2",
                            display: "block",
                          },
                          attrs: { src: "/images/11-38-42-66_512.webp" },
                        }),
                        _vm._v(" "),
                        _c("center", [
                          _vm._v("The AI process is running. Please wait."),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.is_ready
                  ? _c("div", { staticClass: "pta-ai-results" }, [
                      _c(
                        "table",
                        {
                          attrs: {
                            cellpadding: "0",
                            cellspacing: "0",
                            width: "100%",
                          },
                        },
                        [
                          _c("tr", [
                            _c("td", { attrs: { width: "140" } }, [
                              _vm._v("ESG"),
                            ]),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.transscript.esg
                                    ? _vm.transscript.esg
                                    : "-"
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("FTF")]),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.transscript.ftf
                                    ? _vm.transscript.ftf
                                    : "-"
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Fundtype")]),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.transscript.fundtype
                                    ? _vm.transscript.fundtype
                                    : "-"
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Geography")]),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.transscript.geography
                                    ? _vm.transscript.geography
                                    : "-"
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Invstructure")]),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.transscript.invstructure
                                    ? _vm.transscript.invstructure
                                    : "-"
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Policy")]),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.transscript.policy
                                    ? _vm.transscript.policy
                                    : "-"
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Summary")]),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.transscript.summary
                                    ? _vm.transscript.summary
                                    : "-"
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Ticketsize")]),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.transscript.ticketsize
                                    ? _vm.transscript.ticketsize
                                    : "-"
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Holding period")]),
                            _c("td", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.transscript.period
                                    ? _vm.transscript.period
                                    : "-"
                                ),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticStyle: { clear: "left" } }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }